import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type AlipayProps = Omit<BusinessIconImageProps, 'color' | 'strokeWidth'>;

const Alipay = forwardRef<SVGSVGElement, AlipayProps>(
  ({ size = 24, width, height, alt = '', style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={style}
      {...props}
    >
      <g transform="translate(-2.246159 -2.594355) scale(1.188342)">
        <path d="M21.8663 15.9321V6.19622C21.8663 4.09673 20.1655 2.39355 18.0674 2.39355H5.90918C3.81175 2.39355 2.11023 4.09605 2.11023 6.19622V18.3663C2.11023 20.4658 3.81107 22.169 5.90918 22.169H18.0674C19.9367 22.169 21.4914 20.8168 21.8076 19.036C20.8006 18.6023 16.433 16.715 14.159 15.6262C12.4285 17.7248 10.6154 18.984 7.88255 18.984C5.14968 18.984 3.32601 17.3012 3.54587 15.2379C3.69018 13.8837 4.6178 11.6728 8.645 12.0531C10.7676 12.2535 11.7395 12.6499 13.4722 13.2208C13.9175 12.3994 14.2912 11.4948 14.5718 10.5319H6.89742V9.7713H10.6939V8.40225H6.06208V7.5656H10.6939V5.59331C10.6939 5.59331 10.7376 5.28382 11.0765 5.28382H12.9761V7.5656H17.9152V8.40225H12.9761V9.7713H17.0033C16.6341 11.2815 16.0733 12.6669 15.3691 13.8794C16.5406 14.3024 21.8663 15.9321 21.8663 15.9321ZM7.58118 17.6814C4.69373 17.6814 4.23785 15.856 4.38981 15.0954C4.54177 14.3348 5.37762 13.346 6.98282 13.346C8.82866 13.346 10.479 13.8175 12.4626 14.7846C11.0712 16.5996 9.35842 17.6814 7.5812 17.6814H7.58118Z" fill="#00B1F0" />
      </g>
    </svg>
  ),
);

Alipay.displayName = 'Alipay';

export default Alipay;
